/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { EXPERIENCE_DOMAIN_CONFIG, hjsv, hotjarIdConfig } from '../constants';

declare global {
  interface Window {
    hj: any;
    _hjSettings: any;
  }
}

export default function installHotjar(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (window.hj) {
      resolve();
    } else {
      (function (h, o, t, j) {
        h.hj =
          h.hj ||
          function () {
            (h.hj.q = h.hj.q || []).push(arguments);
          };
        const host = window.location.hostname as EXPERIENCE_DOMAIN_CONFIG;
        h._hjSettings = { hjid: hotjarIdConfig[host], hjsv };
        const a = o.getElementsByTagName('head')[0];
        const r = o.createElement('script');
        r.async = true;
        r.onload = () => {
          resolve();
        };
        r.onerror = () => {
          reject();
        };
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
      })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    }
  });
}
